import {call, put} from "redux-saga/effects";
import {loginApi, registerMfaApi, sendOtpMailApi} from "../../../../common/apis/authApi";
import * as actions from "../state/loginActions";



export function* loginSaga({ payload }) {
    try {
        const response = yield call(loginApi, payload);
        const body = response.data.body;


        if (body?.requireOTP === "true") {
            yield put(actions.loginSuccessAction(null, null, null, body));
            return;
        }

        if (typeof body === 'object' && body?.qrCodeUrl) {
            yield put(actions.loginSuccessAction(null, body.qrCodeUrl, body.secret));
            return;
        }

        const token = body?.token; 
        sessionStorage.setItem('token', token);
        yield put(actions.loginSuccessAction(token));

    } catch (error) {
        yield put(actions.loginFailAction(
            error?.response?.data?.message || error?.message || 'Login failed'
        ));
    }
}

export function* registerMFASaga(action) {
    try {
        const response = yield call(registerMfaApi, action.payload);
        const token = response.data?.body?.token;

        if (!token) {
            yield put(actions.registerMFAFailure(
                response?.data?.message || "Code OTP incorrect"
            ));
            return;
        }

        sessionStorage.setItem('token', token);
        yield put(actions.registerMFASuccess(response.data));

    } catch (error) {
        yield put(actions.registerMFAFailure(error?.response?.data?.message || error?.message));
    }
}



export function* sendOtpMailSaga(action) {
    try {
        const response = yield call(sendOtpMailApi, action.payload);
        yield put(actions.sendOtpMailSuccess(response.data));
    } catch (error) {
        yield put(actions.sendOtpMailFailure(
            error?.response?.data?.message || error?.message
        ));
    }
}
